import { UserRole } from "./user-role";

export enum UserPermissionType {
  SERVICE_REQUESTS_MANAGE = "servicerequests.manage",
  VISITS_MANAGE = "visits.manage",
  BOOKING_FOR_GUESTS_MANAGE = "booking_for_guests.manage",
  BOOKING_FOR_OTHERS_MANAGE = "booking_for_others.manage",
  OFFICE_ANALYTICS_EXPORT = "office_analytics.export",
  OFFICE_ANALYTICS_VIEW = "office_analytics.view",
  WORKFORCE_ANALYTICS_VIEW = "workforce_analytics.view",
  WORKFORCE_ANALYTICS_EXPORT = "workforce_analytics.export",
  ADVANCED_ANALYTICS_EXPORT = "advanced_analytics.export",
  WORKPLACE_TICKETING_MANAGE = "workplace_ticketing.manage",
}

/**
 * Maps admin page route segments to their corresponding UserPermissionType.
 * Used to identify which custom role permissions apply to specific admin routes.
 */
export const ADMIN_PAGE_CUSTOM_PERMISSIONS: Record<string, UserPermissionType> = {
  "office-analytics": UserPermissionType.OFFICE_ANALYTICS_VIEW,
  "people-analytics": UserPermissionType.WORKFORCE_ANALYTICS_VIEW,
  "advanced-analytics": UserPermissionType.ADVANCED_ANALYTICS_EXPORT,
};

/**
 * Maps admin page route segments to roles that should ONLY use offices from their
 * custom permissions on those pages.
 */
export const PAGES_ROLES_WITH_CUSTOM_PERMISSIONS_ONLY: Map<string, UserRole[]> = new Map([
  ["office-analytics", [UserRole.USER, UserRole.GROUP_MANAGER, UserRole.MANAGER]],
  ["advanced-analytics", [UserRole.USER, UserRole.GROUP_MANAGER, UserRole.MANAGER]],
]);
